export const BACK_BUTTON_LABEL = {
  DEALREVIEW_INREVIEW: "Back to DR in review",
  LEGALREVIEW_NEW: "Back to legal review",
  LEGALREVIEW_INREVIEW: "Back to legal in review",
  LEGALREVIEW_INPROCESS: "Back to legal in process",
  LEGALREVIEW_COMPLETED: "Back to  legal complete",
  LEGALREVIEW_DEALLOST: "Back to legal lost ",
  RM_DEMAND_PIPELINE_PRELIMINARY_NEW: "Back to preliminary Demand",
  RM_DEMAND_PIPELINE_PRELIMINARY_INPROGRESS: "Back to preliminary demand",
  RM_DEMAND_PIPELINE_PRELIMINARY_COMPLETED: "Back to preliminary demand",
  RM_DEMAND_PIPELINE_PRELIMINARY_LOST: "Back to preliminary demand",
  RM_DEMAND_PIPELINE_PROJECT_DEMAND_NEW: "Back to project demand",
  RM_DEMAND_PIPELINE_OTHER_DEMAND_SCOPED: "Back to other demand",
  RM_DEMAND_PIPELINE_OTHER_DEMAND_DISCOVERY: "Back to other demand",
  RM_DEMAND_PIPELINE_OTHER_DEMAND_QUALIFIED: "Back to other demand",
  RM_RESOURCE_ALLOCATION_NEW: "Back to resource allocation",
  RM_RESOURCE_ALLOCATION_INPROGRESS: "Back to RM in progress",
  RM_RESOURCE_ALLOCATION_PARTIALLY_COMPLETED: "Back to RM partially complete",
  RM_RESOURCE_ALLOCATION_COMPLETED: "Back to RM complete",
  ACCESS_POLICY_FIRST_STEP: "Back to access policy",
  DEALREVIEW_INPROGRESS: "Back to deal review",
  DEALREVIEW_REOPEN: "Back to DR reopened",
  DEALREVIEW_APPROVED: "Back to DR approved",
  DEALREVIEW_LEGAL_PENDING: "Back to DR legal pending",
  DEALREVIEW_COMPLETED: "Back to DR complete",
  DEALREVIEW_DEALLOST: "Back to lost deals",
  SCOPED_NEW: "Back to scoped deals",
  SCOPED_INPROGRESS: "Back to scoped deals",
  SCOPED_COMPLETED: "Back to scoped deals",
  INAB_NEW_SUBMISSION: "Back to inab submissions",
  INAB_NEW: "Back to inab deals",
  INAB_PROJECT_INFLIGHT: "Back to inab projects",
  INAB_APPROVED: "Back to approved inab deals",
  INAB_COMPLETED: "Back to completed inab deals",
  INAB_CANCELLED: "Back to cancelled inab deals",
  INAB_REJECTED: "Back to rejected inab deals",
  DEALREVIEW_NEW: "Back to deal review",
  LEGALREVIEW_INPROGRESS: "Back to legal reviews",
  PROJECTS_UPCOMING: "Back to upcoming projects",
  PROJECTS_ACTIVE: "Back to active projects",
  PROJECTS_COMPLETED: "Back to completed projects",
  PROJECTS_WAVICLE_NEW: "Back to wavicle projects",
  PROJECTS_WAVICLE_INPROGRESS: "Back to wavicle projects in progress",
  PROJECTS_WAVICLE_COMPLETED: "Back to completed wavicle projects",
  RM_PEOPLE: "Back to people",
  RM_DEMAND_PIPELINE_PROJECT_DEMAND_EXTEND: "Back to project demand",
  RM_DEMAND_PIPELINE_PROJECT_DEMAND_REPLACE: "Back to project demand",
  RM_DEMAND_PIPELINE_PROJECT_DEMAND_REMOVE: "Back to project demands",
  PROFILE: "Back to profile",
  ACCESS_POLICY_SECOND_STEP: "Back to name and description",
  PLAYGROUND_WORKBOOK: "Back to Workbook"
};
